import React, { useEffect, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import JSONDigger from "json-digger";
import classnames from "classnames";
import { v4 as uuidv4 } from "uuid";
import { connect } from "react-redux";
import { sendUpdatedJson } from "./nodeUserFunctions";
import PropTypes from 'prop-types';

const ScenarioEditorModal = (props) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [newNodes, setNewNodes] = useState([{ name: "", title: "" }]);
  //  const [submitButton, setSubmitButton] = useState("");
  const [ds, setDS] = useState(props.datasource);
  const dsDigger = new JSONDigger(ds, "id", "children");
  const [selectedNodes, setSelectedNodes] = useState(new Set());
  const [activeTab, setActiveTab] = useState("edit");
  const [filter] = useState(props.filter)

  useEffect(() => {
    if (props.content) {
      setSelectedNodes(props.content);
      Array.from(props.content).forEach(
        (node) => { setName(node.name); setDescription(node.title) }
      );
    }
  },[props.content]
  );

  const onNameChange = (e) => {
    newNodes[0].name = e.target.value;
    setNewNodes([...newNodes]);
  };

  const onTitleChange = (e) => {
    newNodes[0].title = e.target.value;
    setNewNodes([...newNodes]);
  };

  const getNewNodes = () => {
    const nodes = [];
    for (const node of newNodes) {
      nodes.push({ ...node, id: uuidv4() });
    }
    return nodes;
  };

  const onSubmitUpdate = async (e) => {
    e.preventDefault();
    if (selectedNodes.size !== 0) {
      await dsDigger.updateNodes(
        [...props.content].map((node) => node.id),
        { id: uuidv4(), name: newNodes[0].name, title: newNodes[0].title }
      );
      setDS({ ...dsDigger.ds });
    }
    if (!filter) {
      sendUpdatedJson(
        ds,
        `${window.location.origin}/scenario_editor_send_json`
      ).then((response) => {
        if (response && response.status === 200) {
          console.log(response.data);
          props.handleEditModalClose();
        }
      });
    }
    else {
      props.handleEditModalClose();
    }
  };
  // const ScenarioEditorModal = (props) => {
  //   const [name, setName] = useState("");
  //   const [description, setDescription] = useState("");
  //   const [newNodes, setNewNodes] = useState([{ name: "", title: "" }]);
  // //  const [submitButton, setSubmitButton] = useState("");
  //   const [ds, setDS] = useState(props.datasource);
  //   const dsDigger = new JSONDigger(ds, "id", "children");
  //   const [selectedNodes, setSelectedNodes] = useState(new Set());
  //   const [activeTab, setActiveTab] = useState("edit");
  //   const [filter] = useState(props.filter)

  //   useEffect(() => {
  //     if (props.content) {
  //       setSelectedNodes(props.content);
  //       Array.from(props.content).map(
  //         (node) => (setName(node.name), setDescription(node.title))
  //       );
  //     }
  //   }, []);

  //   const onNameChange = (e) => {
  //     newNodes[0].name = e.target.value;
  //     setNewNodes([...newNodes]);
  //   };

  //   const onTitleChange = (e) => {
  //     newNodes[0].title = e.target.value;
  //     setNewNodes([...newNodes]);
  //   };

  //   const getNewNodes = () => {
  //     const nodes = [];
  //     for (const node of newNodes) {
  //       nodes.push({ ...node, id: uuidv4() });
  //     }
  //     return nodes;
  //   };

  //   const onSubmitUpdate = async (e) => {
  //     e.preventDefault();
  //     if (selectedNodes.size !== 0) {
  //       await dsDigger.updateNodes(
  //         [...props.content].map((node) => node.id),
  //         { id: uuidv4(), name: newNodes[0].name, title: newNodes[0].title }
  //       );
  //       setDS({ ...dsDigger.ds });
  //     }
  //     if (!filter) {
  //       sendUpdatedJson(
  //         ds,
  //         `${window.location.origin}/scenario_editor_send_json`
  //         ).then((response) => {
  //           if (response && response.status === 200) {
  //             console.log(response.data);
  //             props.handleEditModalClose();
  //           }
  //         });
  //       }
  //       else {
  //         props.handleEditModalClose();
  //       }
  //     };

  const onSubmitAdd = async (e) => {
    e.preventDefault();
    if (selectedNodes.size !== 0) {
      await dsDigger.addChildren([...selectedNodes][0].id, getNewNodes());
      setDS({ ...dsDigger.ds });
    }
    console.log(ds)
    if (!filter) {
      sendUpdatedJson(
        ds,
        `${window.location.origin}/scenario_editor_send_json`
      ).then((response) => {
        if (response && response.status === 200) {
          console.log(response.data);
          props.handleEditModalClose();
        }
      });
    }
    else {
      props.handleEditModalClose();
    }
  };

  const remove = async () => {
    if (selectedNodes.size !== 0) {
      await dsDigger.removeNodes([...selectedNodes].map((node) => node.id));
      setDS({ ...dsDigger.ds });
      setSelectedNodes(new Set());
    }
    if (!filter) {
      sendUpdatedJson(
        ds,
        `${window.location.origin}/scenario_editor_send_json`
      ).then((response) => {
        if (response && response.status === 200) {
          console.log(response.data);
          props.handleEditModalClose();
        }
      });
    }
    else {
      props.handleEditModalClose();
    }
  };

  const onActiveTab = (activeTab) => {
    setActiveTab(activeTab);
  };

  return (
    <div>
      <Modal isOpen={!!props.editSelectedRow}>
        <ModalHeader
          toggle={props.handleEditModalClose}
          style={{ color: "#524fa1" }}
        >
          ADD/EDIT NODE
        </ModalHeader>
        <ModalBody>
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <Nav tabs>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "edit" })}
                        onClick={(e) => onActiveTab("edit")}
                      >
                        Edit
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "add" })}
                        onClick={(e) => onActiveTab("add")}
                      >
                        ADD
                      </NavLink>
                    </NavItem>
                  </Nav>
                </div>
              </div>
              <TabContent activeTab={activeTab}>
                <TabPane tabId="edit">
                  <div className="card card-body mt-2">
                    <div className="row">
                      <div className="col-md-12">
                        <div
                          className="card card-body"
                          style={{ border: "0px" }}
                        >
                          <form onSubmit={onSubmitUpdate}>
                            <div className="form-group">
                              <label style={{ color: "#524fa1" }}>
                                Node Name
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder={name}
                                onChange={(e) => onNameChange(e)}
                              />
                            </div>
                            <div className="form-group">
                              <label style={{ color: "#524fa1" }}>
                                Node Description
                              </label>
                              <textarea type="text" className="form-control" placeholder={description} onChange={(e) => onTitleChange(e)} rows={5} />
                            </div>
                            <Button
                              type="submit"
                              className="btn"
                              style={{ backgroundColor: "#753DFF" }}
                            >
                              Update
                            </Button>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </TabPane>
                <TabPane tabId="add">
                  <div className="card card-body mt-2">
                    <div className="row">
                      <div className="col-md-12">
                        <div
                          className="card card-body"
                          style={{ border: "0px" }}
                        >
                          <form onSubmit={onSubmitAdd}>
                            <div className="form-group">
                              <label style={{ color: "#524fa1" }}>
                                Node Name
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Name"
                                onChange={(e) => onNameChange(e)}
                              />
                            </div>
                            <div className="form-group">
                              <label style={{ color: "#524fa1" }}>
                                Node Description
                              </label>
                              <textarea type="text" className="form-control" placeholder="Description" onChange={(e) => onTitleChange(e)} rows={5} />
                            </div>
                            <Button
                              type="submit"
                              className="btn"
                              style={{ backgroundColor: "#753DFF" }}
                            >
                              Add
                            </Button>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </TabPane>
              </TabContent>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={remove}>
            Delete Node
          </Button>
          <Button color="secondary" onClick={props.handleEditModalClose}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};
ScenarioEditorModal.propTypes = {
  filter: PropTypes.string,
  content: PropTypes.string,
  handleEditModalClose: PropTypes.string,
  editSelectedRow: PropTypes.string,
  datasource: PropTypes.string,
}
ScenarioEditorModal.defaultProps = {
  filter: [],
  content: [],
  handleEditModalClose: [],
  editSelectedRow: [],
  datasource: [],
}

// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }

export default connect()(ScenarioEditorModal);

